import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-container">
      <div className="about-content">
        {/* Header Section */}
        <div className="about-header">
          <h1>📊 About ACO Insights</h1>
          <p className="about-tagline">
            Comprehensive healthcare analytics platform for Accountable Care Organizations
          </p>
        </div>

        {/* Overview Section */}
        <section className="about-section">
          <h2>Platform Overview</h2>
          <p>
            ACO Insights is a powerful analytics platform designed to help healthcare organizations 
            manage population health, control costs, and improve quality outcomes. Our platform provides 
            real-time insights from CMS claims data to support data-driven decision making.
          </p>
        </section>

        {/* Key Features */}
        <section className="about-section">
          <h2>Key Capabilities</h2>
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-icon">👥</span>
              <h3>Population Analytics</h3>
              <p>Comprehensive views of attributed populations with demographics, risk scores, and chronic conditions.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">💰</span>
              <h3>Cost Management</h3>
              <p>Total cost of care analysis with PMPY metrics and utilization tracking across all service categories.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🏥</span>
              <h3>Utilization Insights</h3>
              <p>Detailed analytics for inpatient, outpatient, post-acute, and emergency department services.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">📈</span>
              <h3>Quality Reporting</h3>
              <p>Preventive care tracking including AWV, IPPE, ACP, and depression screening compliance.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🎯</span>
              <h3>Risk Stratification</h3>
              <p>HCC-based risk scoring and stratification to identify high-risk populations.</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🤖</span>
              <h3>AI-Powered Insights</h3>
              <p>Integrated AI assistant for natural language queries and data exploration.</p>
            </div>
          </div>
        </section>

        {/* Data Sources */}
        <section className="about-section">
          <h2>Data Sources</h2>
          <p>
            Our platform integrates with CMS claims data including:
          </p>
          <ul className="data-list">
            <li><strong>Inpatient Claims:</strong> Acute care hospitalizations and procedures</li>
            <li><strong>Outpatient Claims:</strong> Ambulatory services and procedures</li>
            <li><strong>Professional Claims:</strong> Physician and provider services</li>
            <li><strong>Part D Claims:</strong> Prescription drug utilization</li>
            <li><strong>Post-Acute Claims:</strong> SNF, HHA, and hospice services</li>
            <li><strong>Demographic Data:</strong> Member enrollment and risk scores</li>
          </ul>
        </section>

        {/* Technology Stack */}
        <section className="about-section">
          <h2>Technology</h2>
          <div className="tech-stack">
            <div className="tech-item">
              <strong>Frontend:</strong> React, Recharts
            </div>
            <div className="tech-item">
              <strong>Backend:</strong> Python, FastAPI
            </div>
            <div className="tech-item">
              <strong>Database:</strong> Google BigQuery
            </div>
            <div className="tech-item">
              <strong>AI:</strong> Google Vertex AI
            </div>
          </div>
        </section>

        {/* Security & Privacy */}
        <section className="about-section">
          <h2>Security & Privacy</h2>
          <p>
            We take data security and privacy seriously. Our platform implements:
          </p>
          <ul className="security-list">
            <li>OAuth 2.0 authentication with Google</li>
            <li>Role-based access control (RBAC)</li>
            <li>Data encryption in transit and at rest</li>
            <li>HIPAA-compliant data handling</li>
            <li>Audit logging of all data access</li>
          </ul>
        </section>

        {/* Contact Section */}
        <section className="about-section contact-section">
          <h2>Support & Contact</h2>
          <p>
            For questions, support, or more information about ACO Insights, please contact:
          </p>
          <div className="contact-info">
            <p><strong>Email:</strong> support@acoinsights.com</p>
            <p><strong>Documentation:</strong> docs.acoinsights.com</p>
            <p><strong>Version:</strong> 2.0.0</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;
